import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { ConfigurationItem } from "../_objects/tenant-config";
import { TenantConfig } from "../app.constants";
import { INSPECTION_STRUCTURE_FORMAT, InspectionStructureFormat } from "../_utils/inspection-structure.utils";
import { TenantConfigService } from "./http-api/tenant-config.service";
import { NetworkStatusService } from "./network-status.service";

/**
 * Tells which layout an inspection structure export, a P2P send or an inspection export uses.
 * IPLEX One always uses the display name tree. Everywhere else the tenant setting
 * "Inspection structure export format" decides, legacy flat folders being the default.
 */
@Injectable({
  providedIn: "root"
})
export class InspectionStructureFormatService {
  constructor(
    private tenantConfigService: TenantConfigService,
    private networkStatusService: NetworkStatusService
  ) {}

  async resolveFormat(): Promise<InspectionStructureFormat> {
    if (this.networkStatusService.isBrianMode) {
      return INSPECTION_STRUCTURE_FORMAT.TREE;
    }

    const configs = this.tenantConfigService.tenantConfig ?? (await this.fetchTenantConfigs());
    const value = configs?.find((config) => config.key === TenantConfig.InspectionStructureFormat.KEY)?.value;
    return Number(value) === TenantConfig.InspectionStructureFormat.TREE ? INSPECTION_STRUCTURE_FORMAT.TREE : INSPECTION_STRUCTURE_FORMAT.LEGACY;
  }

  private async fetchTenantConfigs(): Promise<ConfigurationItem[] | null> {
    try {
      return await firstValueFrom(this.tenantConfigService.getTenantConfigs());
    } catch (error) {
      console.error("Tenant configuration could not be read; the legacy structure format is used", error);
      return null;
    }
  }
}
